import { IPreferencesDTO, IUpdatePreferencesRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';

export default class PreferencesRepository extends ESSRepository {
  private static readonly baseRoute = '/preferences';
  private static readonly apiURL = PreferencesRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<IPreferencesDTO> => {
    try {
      const { data } = await http.get<IPreferencesDTO>(PreferencesRepository.apiURL);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getDefault = async (): Promise<IPreferencesDTO> => {
    try {
      const { data } = await http.get<IPreferencesDTO>(`${PreferencesRepository.apiURL}/default`);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public patch = async (payload: IUpdatePreferencesRequestDTO): Promise<IPreferencesDTO> => {
    try {
      const { data } = await http.patch<{ updatedPreferences: IPreferencesDTO }>(PreferencesRepository.apiURL, payload);
      return data.updatedPreferences;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
